import { Box, alpha, styled } from '@ltvco/refresh-lib/theme';

import type { StatusSeverity } from '../utils';

export { CardContainer } from '../../CardContainer';

export const HeaderRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  marginBottom: 16,
});

export const HeaderTitle = styled('span')(({ theme }) => ({
  fontSize: 18,
  fontWeight: 600,
  color: theme.palette.text.primary,
}));

export const PhoneNumberRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: 4,
});

export const PhoneNumber = styled('span')(({ theme }) => ({
  fontSize: 22,
  fontWeight: 700,
  color: theme.palette.text.primary,
}));

export const FraudBadge = styled(Box)<{ severity?: string }>(
  ({ theme, severity }) => {
    const isHigh = severity === 'high';
    const isLow = severity === 'low';

    return {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 6,
      padding: '4px 12px',
      borderRadius: 20,
      backgroundColor: isHigh
        ? theme.palette.error.light
        : isLow
        ? theme.palette.success.light
        : alpha(theme.palette.warning.light, 0.2),
      color: isHigh
        ? theme.palette.error.dark
        : isLow
        ? theme.palette.success.dark
        : theme.palette.warning.main,
      fontSize: 13,
      fontWeight: 600,
    };
  }
);

export const SectionDivider = styled('hr')(({ theme }) => ({
  border: 'none',
  borderTop: `1px solid ${theme.palette.divider}`,
  margin: '16px 0',
}));

export const StatusRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 16,
  flexWrap: 'wrap',
  marginBottom: 0,
});

export const StatusLabel = styled('span')(({ theme }) => ({
  fontSize: 14,
  fontWeight: 600,
  color: theme.palette.text.primary,
  marginRight: 4,
}));

export const StatusItem = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 8,
  fontSize: 14,
  color: theme.palette.text.secondary,
}));

export const StatusIconWrapper = styled(Box)<{ severity: StatusSeverity }>(
  ({ theme, severity }) => ({
    width: 24,
    height: 24,
    borderRadius: '50%',
    backgroundColor:
      severity === 'warning'
        ? alpha(theme.palette.warning.light, 0.2)
        : theme.palette[severity].light,
    color: theme.palette[severity].main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  })
);

export const SectionHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  marginBottom: 12,
  color: theme.palette.rats.main,
}));

export const SectionTitle = styled('span')({
  fontSize: 15,
  fontWeight: 600,
});

export const DetailGrid = styled(Box)({
  display: 'grid',
  gridTemplateColumns: '140px 1fr',
  rowGap: 8,
  marginBottom: 0,
});

export const DetailLabel = styled('span')(({ theme }) => ({
  fontSize: 14,
  fontWeight: 600,
  color: theme.palette.rats.main,
}));

export const DetailValue = styled('span')(({ theme }) => ({
  fontSize: 14,
  color: theme.palette.text.primary,
}));

export const OwnerRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
});

export const OwnerInfo = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 10,
});

export const OwnerAvatar = styled(Box)(({ theme }) => ({
  width: 32,
  height: 32,
  borderRadius: '50%',
  backgroundColor: theme.palette.button.light,
  color: theme.palette.primary.main,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: 13,
  fontWeight: 600,
  flexShrink: 0,
}));

export const OwnerName = styled('span')(({ theme }) => ({
  fontSize: 15,
  fontWeight: 600,
  color: theme.palette.text.primary,
}));
